import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAdmin = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-admin';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.542 3.285a4.4 4.4 0 0 0-1.929.701c-.795.527-1.449 1.452-1.721 2.434-.101.365-.111.46-.111 1.08 0 .617.01.716.109 1.071.376 1.351 1.291 2.377 2.57 2.881.538.212.912.28 1.54.28.751 0 1.249-.116 1.915-.446a4.28 4.28 0 0 0 2.027-2.211c.229-.582.275-.846.275-1.575s-.046-.993-.275-1.575c-.292-.743-.907-1.51-1.554-1.939a5.5 5.5 0 0 0-1.268-.581c-.24-.066-1.115-.182-1.2-.16-.011.003-.181.021-.378.04M12.62 4.82c.926.192 1.792 1.033 2.042 1.98.091.35.091 1.05 0 1.4-.122.461-.361.862-.741 1.241-.557.557-1.139.799-1.921.799s-1.364-.242-1.921-.799C9.504 8.867 9.27 8.306 9.27 7.5s.234-1.367.809-1.941c.387-.387.826-.64 1.281-.737a3.6 3.6 0 0 1 1.26-.002M4.544 16.87c-1.157 1.447-2.104 2.642-2.104 2.656s.258.232.572.485l.573.459 1.877-2.353 1.878-2.353 3.83-.002L15 15.76v-1.52H6.648zm13.765-1.562c-.096.15-.393.625-.662 1.056l-.488.783-1.23.272c-.676.149-1.251.283-1.277.297-.03.016.271.38.81.979.472.525.857.975.856 1s-.052.585-.114 1.245c-.061.66-.108 1.205-.104 1.211.004.005.536-.206 1.182-.47A27 27 0 0 1 18.5 21.2c.024 0 .572.216 1.218.481.646.264 1.178.475 1.182.47s-.043-.551-.104-1.211c-.062-.66-.113-1.22-.114-1.245s.384-.475.856-1c.539-.599.84-.963.81-.979a31 31 0 0 0-1.278-.297l-1.229-.272-.645-1.034c-.355-.569-.661-1.044-.68-1.055-.019-.012-.112.101-.207.25"
    })
  }));
});
export default SvgAdmin;